
const getRequestParams = () =>
{
    const params = {};
    if( window.location.search )
    {
        let qs = window.location.search.substring(1).split('&');
        qs.forEach( function(arg){
            let param = arg.split('=');
            params[param[0]] = param[1];
        });
    }
    return params;
}

export default getRequestParams;